import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentType } from '@shared/types/document.types';

export function fileAttachments(
  translateService: TranslateService,
  isAttachmentTypePreselected?: boolean,
  showDescription?: boolean
): Array<FormlyFieldConfig> {
  return [
    {
      wrappers: [],
      fieldGroup: [
        {
          type: 'chapter',
          props: {
            chapterTitle: translateService.instant(
              'ticket.create.headline__attachment'
            ),
            description: showDescription
              ? translateService.instant('ticket.create.label__notice_info')
              : null,
            visibleInConfirm: true,
          },
        },
        {
          key: 'attachments',
          type: 'repeat',
          props: {
            maxItems: 10,
            addText: translateService.instant(
              'ticket.create.button__attach_new_file'
            ),
            tooltip: isAttachmentTypePreselected
              ? translateService.instant(
                  'ticket.create.p__info_attachment_preselected'
                )
              : translateService.instant('ticket.create.p__info_attachment'),
          },

          fieldArray: {
            type: 'flex-layout-col',

            fieldGroup: [
              {
                type: 'select',
                key: 'attachmentType',
                id: 'fileAttachment',
                defaultValue: isAttachmentTypePreselected
                  ? DocumentType.Sonstiges
                  : null,
                props: {
                  label: translateService.instant(
                    'ticket.create.select__type_of_file'
                  ),
                  required: true,
                  disabled: isAttachmentTypePreselected ?? false,
                  visibleInConfirm: true,
                  options: [
                    {
                      label: 'Flurstückskarte',
                      value: DocumentType.AmtlicheUnterlagenGrundstueck,
                    },
                    {
                      label: 'Grundbuchauszug',
                      value: DocumentType.AmtlicheUnterlagenGrundstueck,
                    },
                    { label: 'Pläne', value: DocumentType.Plaene },
                    {
                      label: 'Schriftverkehr',
                      value: DocumentType.Schriftverkehr,
                    },
                    { label: 'Sonstiges', value: DocumentType.Sonstiges },
                  ].sort((a, b) => {
                    if (a.label === b.label) {
                      return 0;
                    }
                    return a.label < b.label ? -1 : 1;
                  }),
                },
              },
              {
                type: 'file',
                key: 'attachment',
                props: {
                  label: translateService.instant(
                    'ticket.create.label__attachment'
                  ),
                  visibleInConfirm: true,
                  accept:
                    '.jpg, .jpeg, .png, .pdf, .txt, .tif, .tiff, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .msg, .zip',
                  maxFileSizeInMB: '10',
                  required: true,
                },
              },
            ],
          },
        },
      ],
    },
  ];
}

export function fileAttachmentSingle(
  translateService: TranslateService,
  description?: string,
  required?: boolean
): Array<FormlyFieldConfig> {
  return [
    {
      wrappers: [],
      fieldGroup: [
        {
          type: 'chapter',
          props: {
            chapterTitle: translateService.instant(
              'ticket.create.headline__attachment'
            ),
            description,
            visibleInConfirm: true,
          },
        },

        {
          type: 'file',
          key: 'attachment',
          props: {
            label: translateService.instant('ticket.create.label__attachment'),
            visibleInConfirm: true,
            accept:
              '.jpg, .jpeg, .png, .pdf, .txt, .tif, .tiff, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .msg, .zip',
            maxFileSizeInMB: '10',
            required: required ?? false,
            showRemoveButton: true,
          },
        },
      ],
    },
  ];
}
